import { useNavigate } from 'react-router-dom';


function ReturnHome(){
    const navigate = useNavigate();
         return(   <button onClick={() => navigate('/')}>Return</button>)
}


export default ReturnHome; 